export enum OnboardingPhase {
  OTP = "otp",
  CREATE_USER = "create_user",
  CREATE_BUSINESS = "create_business",
  VIEW_CONTACTS = "view_contacts",
  COMPLETED = "completed",
}

export function getOnboardingPath(phase: OnboardingPhase) {
  switch (phase) {
    case OnboardingPhase.OTP: {
      return "/otp?type=signup";
    }
    case OnboardingPhase.CREATE_USER: {
      return "/onboarding/user";
    }
    case OnboardingPhase.CREATE_BUSINESS: {
      return "/onboarding/business";
    }
    case OnboardingPhase.VIEW_CONTACTS: {
      return null;
    }
    case OnboardingPhase.COMPLETED: {
      return null;
    }
  }
}
